import { ModalBody, ModalFooter, ModalHeader } from "@nextui-org/react";
import { colors } from "../../../../styles/_variables";
import Button from "../../../Button/Button";
import AccountCard from "../../ui/AccountCard/AccountCard";
import {
  updateAction,
  updateAllariaMasSelectedAccount,
} from "../../../../store/slices/unifiedBalanceSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import styles from "./AllariaMasSelector.module.scss";
import useScreenSize from "../../../../hooks/useScreenSize";

const AllariaMasSelector = () => {
  const dispatch = useAppDispatch();
  const {
    assessmentData: { availablesAllariaMasAccounts },
    allariaMasSelectedAccount,
  } = useAppSelector((state) => state.unifiedBalance);

  const { subtitle, contactContainer, modalHeader, modalFooterMobile, modalMobileHeader } = styles;
  const { isMobile } = useScreenSize();

  const mirroredAccounts = availablesAllariaMasAccounts?.filter(
    (acc) => acc.mirror_status.state === "MIRRORED"
  );

  const notMirroredAccounts = availablesAllariaMasAccounts?.filter(
    (acc) => acc.mirror_status.state === "NOT_MIRRORED"
  );

  return (
    <>
      <ModalHeader className={modalMobileHeader}>
        {!isMobile ? (
          <h1
            style={{
              color: colors.primary[500],
              fontSize: "1.5rem",
              fontWeight: 600,
            }}
          >
            Unificar saldos
          </h1>
        ) : (
          <h1 className={modalHeader}>Unificar saldos</h1>
        )}
      </ModalHeader>
      <ModalBody>
        {/* NOT MIRRORED ACCOUNTS */}
        <p className={subtitle}>
          Encontramos{" "}
          {availablesAllariaMasAccounts?.length === 1 ? "la" : "las"} siguiente
          cuenta disponible registrada con el mismo CUIT:
        </p>

        {notMirroredAccounts?.map((acc) => {
          const { alias, cvu, name, allaria_mas_account_id } = acc;

          return (
            <AccountCard
              key={alias}
              alias={alias}
              cvu={cvu}
              legalName={name}
              isSelected={
                allaria_mas_account_id ===
                allariaMasSelectedAccount?.allaria_mas_account_id
              }
              onClick={() => dispatch(updateAllariaMasSelectedAccount(acc))}
            />
          );
        })}

        {/* MIRRORED ACCOUNTS */}
        {mirroredAccounts?.length > 0 && (
          <>
            <p className={subtitle}>Cuentas no disponibles</p>
            {mirroredAccounts?.map((acc) => {
              const { alias, cvu, name, allaria_mas_account_id } = acc;

              return (
                <AccountCard
                  key={alias}
                  alias={alias}
                  cvu={cvu}
                  legalName={name}
                  isSelected={
                    allaria_mas_account_id ===
                    allariaMasSelectedAccount?.allaria_mas_account_id
                  }
                  onClick={() => dispatch(updateAllariaMasSelectedAccount(acc))}
                  isMirrored={true}
                />
              );
            })}
          </>
        )}

        <div className={contactContainer}>
          <p>
            ¿No encontrás tu cuenta? <span>Contactar a soporte</span>
          </p>
          <p>
            ¿Querés abrir una nueva cuenta comitente? <span>Abrir cuenta</span>
          </p>
        </div>
      </ModalBody>
      <ModalFooter
        className={!isMobile ? "flex justify-center items-center" : modalFooterMobile}
      >
        <div className={isMobile ? modalFooterMobile : "flex gap-4"}>
          <Button
            variant="secondary"
            text="Volver"
            onPress={() => {
              dispatch(updateAction("ACCOUNTS_SELECTOR"));
              dispatch(updateAllariaMasSelectedAccount(null));
            }}
            className={isMobile ? "w-full mb-2.5" : ""}
          />
          <Button
            variant="primary"
            text="Continuar"
            isDisabled={!allariaMasSelectedAccount}
            onPress={() => dispatch(updateAction("PRECONFIRM"))}
            className={isMobile ? "w-full" : ""}
          />
        </div>
      </ModalFooter>
    </>
  );
};

export default AllariaMasSelector;
